import { useEffect } from 'react';

export interface FirstRunDevtools {
  restart: () => void;
  reset: () => void;
  capture: (app: string) => void;
  forceReady: (summary?: string) => Promise<void>;
}

// Dev-only: exposes window.__lbFirstRun to re-test first-run on an existing account.
export function useFirstRunDevtools(api: FirstRunDevtools) {
  useEffect(() => {
    if (!import.meta.env.DEV) return;
    const devWindow = window as unknown as { __lbFirstRun?: FirstRunDevtools };
    devWindow.__lbFirstRun = api;
    return () => {
      if (devWindow.__lbFirstRun === api) delete devWindow.__lbFirstRun;
    };
  }, [api]);
}
